// Puppeteer (scripts/generate-route-previews.mjs) expose toujours navigator.webdriver = true.
// Sert à ne jamais figer, dans le HTML pré-rendu statique, un contenu dépendant d'un effet
// asynchrone (géolocalisation, traduction) : ce contenu ne pourrait jamais correspondre à
// l'état initial (avant effets) que le client reproduit à l'hydration, causant une erreur
// React #418 (hydration mismatch).
export function isPrerendering() {
  return typeof navigator !== 'undefined' && navigator.webdriver === true;
}
